




















































import { Component, Vue, Prop } from "vue-property-decorator";
import FileManager from "@/components/files/FileManager.vue";
import { LectureExtraMaterial as ILectureExtraMaterial } from "@/api/models/lecture-extra-material";
import { LectureExtraMaterialCreate as ILectureExtraMaterialCreate } from "@/api/models/lecture-extra-material-create";
import { LectureExtraMaterialEdit as ILectureExtraMaterialEdit } from "@/api/models/lecture-extra-material-edit";
import EditorWithFile from "@/components/EditorWithFile.vue";
import api from "@/getinfo-api";

@Component({
  components: { EditorWithFile, FileManager }
})
export default class LectureExtraMaterialCreate extends Vue {
  @Prop() existExtraMaterial?: ILectureExtraMaterial;
  @Prop() lectureId?: string;
  showSpinner: boolean = false;
  body: string | undefined;
  extraMaterial:
    | ILectureExtraMaterialCreate
    | ILectureExtraMaterial
    | undefined;
  data() {
    return {
      body: undefined,
      extraMaterial: undefined
    };
  }

  save() {
    if (
      this.lectureId &&
      this.extraMaterial &&
      this.instanceOfExtraMaterial(this.extraMaterial)
    ) {
      const material: ILectureExtraMaterialEdit = {
        title: this.$tc(this.$translate.AdditionalLearningMaterials),
        body: this.body,
        sort: 1
      };
      api.LectureExtraMaterialApi.edit(
        this.lectureId,
        this.extraMaterial.id,
        material
      );
      this.$bvModal.hide("extra-modal");
    } else {
      if (this.body) {
        this.extraMaterial = {
          title: this.$tc(this.$translate.AdditionalLearningMaterials),
          body: this.body,
          sort: 1
        };
        this.$bvModal.hide("extra-modal");
        this.$emit("createExtraMaterial", this.extraMaterial);
      }
    }
  }

  deleteExtraMaterial() {
    if (
      this.lectureId &&
      this.extraMaterial &&
      this.instanceOfExtraMaterial(this.extraMaterial)
    ) {
      api.LectureExtraMaterialApi._delete(
        this.lectureId,
        this.extraMaterial.id
      ).then(() => {
        this.extraMaterial = undefined;
        this.body = undefined;
      });
    } else {
      this.extraMaterial = undefined;
      this.body = undefined;
    }
  }

  getExtraMaterialFull() {
    if (
      this.lectureId &&
      this.extraMaterial &&
      this.instanceOfExtraMaterial(this.extraMaterial)
    ) {
      this.showSpinner = true;
      api.LectureExtraMaterialApi.get(this.lectureId, this.extraMaterial.id)
        .then((res: { data: ILectureExtraMaterial }) => {
          this.body = res.data.body;
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  instanceOfExtraMaterial(
    object: ILectureExtraMaterial | ILectureExtraMaterialCreate
  ): object is ILectureExtraMaterial {
    return "id" in object;
  }

  editExtraMaterial() {
    this.$bvModal.show("extra-modal");
    this.getExtraMaterialFull();
  }

  showModal() {
    this.$bvModal.show("extra-modal");
  }

  mounted() {
    if (this.existExtraMaterial) {
      this.extraMaterial = this.existExtraMaterial;
    }
  }
}
